module.exports = __webpack_public_path__ + "static/media/warning-02.e6f6a411.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/warning-02.png
// module id = 579
// module chunks = 3